import styled from '@emotion/styled'

const StyledContainer = styled.div`
  font-family: 'DM Sans', sans-serif;
  font-size: 1.125rem;
  font-weight: bold;
  padding: 0.5rem 0;
  align-items: baseline;
  display: flex;
  .btn-group {
    margin-left: 0.75em;
    font-weight: 700;
    display: flex;
    align-items: center;
  }
  .btn {
    padding: 0 0.5rem;
    cursor: pointer;
  }
`

export default StyledContainer
